import Vue from 'vue'
import axios from 'axios'
import api from '@/api'

import {
    ADD_CATEGORIES,
    ADD_TO_PRODUCTS,
    CREATE_SELECTED_CATEGORY_FOR_LEVEL,
    SET_BLOCK_MODAL_ENABLED,
    SET_BOT_LINK,
    SET_DELIVERY_TIME_MODE,
    SET_FIELD_CUSTOM_FIELDS,
    SET_FIELD_EMAIL,
    SET_FIELD_FULL_ADDRESS,
    SET_FIELD_FULL_NAME,
    SET_FIELD_LOCAL_ADDRESS,
    SET_FIELD_RECIPIENT_PHONE,
    SET_FIELD_MAIN_PHONE,
    SET_FIELD_COMMENT,
    SET_FIELD_ADDRESS,
    SET_FILTER,
    SET_FORCE_GUARD,
    SET_GTM_TAG,
    SET_GUARD_TYPE_ID,
    SET_LINKS,
    SET_LOADING,
    SET_MODAL,
    SET_NEXT_PAGE,
    SET_OUTLET,
    SET_PAYMENT_METHODS,
    SET_PRODUCTS_COUNT_IN_CATEGORIES,
    SET_SELECTED_CATEGORY,
    SET_STATUS,
    SET_TIME_SELECTOR,
    SET_TIMES,
    SET_WEBVIEW_GUARD,
    SET_WEBVIEW_SETTINGS,
    SET_OPEN_LIST_MODIFIRE,
    SET_SELECTED_MODIFIRE,
    SET_DELIVERY_FROM_CITY,
} from '@/store/mutations.type'
import {
    DISABLE_OVERLAY,
    FETCH_OUTLET,
    FETCH_PRODUCTS,
    FETCH_TIMES,
    GET_BASKET,
    MAKE_ORDER,
    SELECT_CATEGORY,
    SET_GLOBAL_ERROR
} from '@/store/actions.type'
import loader from '@/loader'


const state = {
    outlet: null,
    products: [],
    categories: [],
    filter: {
        date: {
            start: null,
            end: null
        }
    },
    selectedCategory: [{
        current: {
            id: null
        },
        previous: {
            id: null
        }
    }],
    openListModifire: null,
    selectedModifire: null,
    deliveryFromCity: '',
}

const getters = {
    deliveryFromCity(state) {
        return state.deliveryFromCity
    },
    getOpenListModifire(state) {
        return state.openListModifire
    },
    getSelectedModifire(state) {
        return state.selectedModifire
    },
    outlet(state) {
        return state.outlet
    },
    filter(state) {
        return state.filter
    },
    outletSettings(state) {
        if (!state.outlet || !state.outlet.data || !state.outlet.data.settings) {
            return null
        }
        return state.outlet.data.settings
    },
    canPerformOrder(state) {
        if (!state.outlet || !state.outlet.data || !state.outlet.data.settings) {
            return false
        }
        const hasAvailableDays = (state.outlet.data.settings.delivery_time.hasOwnProperty('days') && Object.values(state.outlet.data.settings.delivery_time.days).some(day => (day.length > 0)))
        return state.outlet.data.settings.delivery_time.today.length !== 0 || state.outlet.data.settings.delivery_time.tomorrow.length !== 0 || hasAvailableDays
    },
    deliveryServices(state) {
        return state.outlet.data.delivery_services
    },
    products(state) {
        return state.products
    },
    categories(state) {
        return state.categories
    },
    selectedCategory(state) {
        return state.selectedCategory
    },
    country(state) {
        return state.outlet.data.country
    },
    enable_check_pin_code(state) {
        return state.enable_check_pin_code
    }
}

export const actions = {
    [SELECT_CATEGORY](context, payload) {
        if (context.getters.loading[SELECT_CATEGORY] === true && !payload.ignoreBlock) {
            return
        }

        if (payload.block) {
            context.commit(SET_LOADING, { process: SELECT_CATEGORY, loading: true })
        }
        context.commit(SET_SELECTED_CATEGORY, payload)
    },

    [FETCH_TIMES](context) {
        return axios({
            method: 'POST',
            url: api.outlet.getTimes.url()
        }).then(response => {
            context.commit(SET_TIMES, response.data)
            return response.data
        })
    },

    [FETCH_OUTLET](context, params) {
        axios({
            method: 'POST',
            url: api.outlet.getOutlet.url({
                page: params.page,
                only_popular: Number(params.only_popular),
                get_settings: Number(params.get_settings)
            }, {})
        }).then(async response => {
            if (token !== 'store' || token !== 'guard') {
                context.dispatch(DISABLE_OVERLAY)
            }
            if (!context.getters.isBookingMode)
                context.dispatch(GET_BASKET) // загрузка инфы о корзине

            if (response.data.data.webview_settings) {
                if (
                    (
                        (response.data.data.settings.delivery_type === 3 &&
                            (
                                response.data.data.webview_settings.enabled_address_webview ||
                                (response.data.data.webview_settings.hasDistricts && !response.data.data.settings.company_use_kml)
                            )
                        ) ||
                        ((response.data.data.settings.delivery_type === 1 || response.data.data.settings.delivery_type === 2) && (
                            response.data.data.webview_settings.select_outlet_on_webview ||
                            response.data.data.webview_settings.show_choose_outlets_always
                        )) ||
                        ((response.data.data.settings.delivery_type === 4) && (
                            response.data.data.webview_settings.select_outlet_on_webview ||
                            response.data.data.webview_settings.show_choose_outlets_always
                        ) && context.getters.guardOutlets.length > 1 ) 
                    ) && !context.getters.guardPass
                ) {
                    await context.commit(SET_FORCE_GUARD, true)
                    await context.commit(SET_GUARD_TYPE_ID, response.data.data.settings.delivery_type)
                    return context.commit(SET_WEBVIEW_GUARD, true)
                }
                context.commit(SET_WEBVIEW_SETTINGS, response.data.data.webview_settings)
                context.commit(SET_GTM_TAG, response.data.data.webview_settings.gtmTag)

                if (response.data.data.webview_settings.blockModalEnabled) {
                    context.commit(SET_BLOCK_MODAL_ENABLED, response.data.data.webview_settings.blockModalEnabled)
                    context.commit(SET_MODAL, { modal: 'block', status: true })
                    document.body.classList.add('overflow')
                }

                context.commit(SET_DELIVERY_TIME_MODE, response.data.data.webview_settings.deliveryTimeMode)
                context.commit(SET_TIME_SELECTOR, response.data.data.webview_settings.timeSelector)
                context.commit(SET_FIELD_EMAIL, response.data.data.webview_settings.formEmail)
                context.commit(SET_FIELD_CUSTOM_FIELDS, response.data.data.webview_settings.formCustomFields)
                context.commit(SET_FIELD_FULL_ADDRESS, response.data.data.webview_settings.formFullAddress)
                context.commit(SET_FIELD_FULL_NAME, response.data.data.webview_settings.formFullName)
                context.commit(SET_FIELD_LOCAL_ADDRESS, response.data.data.webview_settings.formLocalAddress)
                context.commit(SET_FIELD_RECIPIENT_PHONE, response.data.data.webview_settings.formRecipientPhone)
                context.commit(SET_FIELD_MAIN_PHONE, response.data.data.webview_settings.formMainPhone)
                context.commit(SET_FIELD_COMMENT, response.data.data.webview_settings.formShowComment)
                context.commit(SET_FIELD_ADDRESS, response.data.data.webview_settings.formOutletAddress)

                if (context.rootState.settings.contactlessMode && !context.rootState.settings.enable_online_payment) {
                    const result = response.data.data.payment_methods.filter(payment => payment.id === 4)
                    context.commit(SET_PAYMENT_METHODS, result)
                } else {
                    context.commit(SET_PAYMENT_METHODS, response.data.data.payment_methods)
                }
            }
            if (response.data.data.city) {
                context.commit(SET_DELIVERY_FROM_CITY, response.data.data.city)
            }

            if (params.get_settings) {
                await context.commit(SET_OUTLET, response.data)
            }
            if (context.getters.outlet.data.acceptance_18_plus) {
                context.commit(SET_MODAL, { modal: 'block', status: true })
            }
            if (context.getters.outletSettings.delivery_type !== 4) {
                if (response.data.data.dishes.hasOwnProperty('data')) {
                    context.commit(ADD_TO_PRODUCTS, response.data.data.dishes.data)
                }
                context.commit(ADD_CATEGORIES, response.data.data.dishes_categories)
            } else {
                context.commit(ADD_CATEGORIES, response.data.data.resources_categories)
                if (response.data.data.resources.hasOwnProperty('data')) {
                    context.commit(ADD_TO_PRODUCTS, response.data.data.resources.data)
                }
            }

            context.commit(SET_LINKS, response.data)
            if (!params.only_popular) {
                context.dispatch(FETCH_PRODUCTS)
            } else {
                context.dispatch(FETCH_OUTLET, { page: 1, only_popular: false, get_settings: false })
            }

            if (
                context.getters.outletSettings.delivery_type !== 4 &&
                !response.data.data.dishes.hasOwnProperty('data') &&
                params.page === 1 &&
                params.only_popular === false
            ) {
                context.dispatch(DISABLE_OVERLAY)
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.bot_link) {
                // if same host
                if (error.response.data.bot_link.indexOf(window.location.host) !== -1) {
                    window.location.hash = error.response.data.bot_link.substr(
                        error.response.data.bot_link.indexOf('#'))
                    window.location.reload()
                } else {
                    window.location = error.response.data.bot_link
                }
            }
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },

    [FETCH_PRODUCTS](context) {
        if (context.getters.outlet.links.hasOwnProperty('next') && !context.getters.outlet.links.next) {
            context.commit(SET_PRODUCTS_COUNT_IN_CATEGORIES, { getters: context.getters })
            context.commit(SET_STATUS, { process: FETCH_PRODUCTS, status: true })
            context.dispatch(DISABLE_OVERLAY)
            return
        }
        axios({
            method: 'POST',
            url: context.getters.outlet.links.next
        }).then(async response => {
            if (context.getters.outletSettings.delivery_type !== 4) {
                await context.commit(ADD_TO_PRODUCTS, response.data.data.dishes.data)
                await context.commit(SET_NEXT_PAGE, response.data.data.dishes.links.next)
            } else {
                await context.commit(ADD_TO_PRODUCTS, response.data.data.resources.data)
                await context.commit(SET_NEXT_PAGE, response.data.data.resources.links.next)
            }
            context.dispatch(FETCH_PRODUCTS)
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    }
}

export const mutations = {
    [SET_DELIVERY_FROM_CITY](state, data) {
        state.deliveryFromCity = data
    },
    [SET_SELECTED_MODIFIRE](state, value) {
        state.selectedModifire = value
    },
    [SET_OPEN_LIST_MODIFIRE](state, value) {
        state.openListModifire = value
    },
    [CREATE_SELECTED_CATEGORY_FOR_LEVEL](state, level) {
        Vue.set(state.selectedCategory, level, {
            current: {
                id: null
            },
            previous: {
                id: null
            }
        })
    },

    [SET_SELECTED_CATEGORY](state, { category, categories, level, selectLastChildren = false }) {

        function selectCategory(
            state, category, categories, level, selectLastChildren = false, checkParent = true) {
            state.selectedCategory[level].current = category

            if (category) {
                for (let i = 0; i < categories.length; i++) {
                    if (categories[i].id === category.id) {
                        if (i === 0) {
                            state.selectedCategory[level].previous = { id: null }
                        } else {
                            state.selectedCategory[level].previous = categories[i - 1]
                        }
                    }
                }
            } else {
                state.selectedCategory[level].previous = { id: null }
            }

            if (selectLastChildren) {
                let children = []
                for (let i = 0; i < state.categories.length; i++) {
                    if (state.categories[i].parent_id === category.id && state.categories[i].level ===
                        category.level + 1) {
                        children.push(state.categories[i])
                    }
                }
                if (children.length) {
                    selectCategory(state, children[children.length - 1], children, category.level + 1,
                        true, false)
                }
            }

            if (checkParent) {
                checkParentSelected(state, category, level, selectLastChildren)
            }

            removeBadChildren(state, category, level)
        }

        function checkParentSelected(state, category, level, selectLastChildren) {
            if (category && category.parent_id) {
                if (state.selectedCategory[level - 1] && state.selectedCategory[level - 1].current.id !==
                    category.parent_id) {
                    let parent = null
                    let parentCategories = []

                    for (let i = 0; i < state.categories.length; i++) {
                        if (state.categories[i].level === category.level - 1) {
                            parentCategories.push(state.categories[i])
                            if (state.categories[i].id === category.parent_id) {
                                parent = state.categories[i]
                            }
                        }
                    }

                    selectCategory(state, parent, parentCategories, level - 1, selectLastChildren)
                }
            }
        }

        function removeBadChildren(state, category, level, purge = false) {
            if (purge) {
                for (let i = level; i < state.selectedCategory.length; i++) {
                    state.selectedCategory[i].current = { id: null }
                }
                return null
            }
            if (state.selectedCategory[level + 1] && state.selectedCategory[level + 1].current.id !==
                null) {
                let child = state.selectedCategory[level + 1].current
                if (child.parent_id !== category.id) {
                    return removeBadChildren(state, child, level + 1, true)
                } else {
                    return removeBadChildren(state, child, level + 1)
                }
            }
        }

        selectCategory(state, category, categories, level, selectLastChildren)
    },

    [SET_PRODUCTS_COUNT_IN_CATEGORIES](state, { getters }) {
        if (getters.outletSettings.delivery_type !== 4) {

            state.outlet.data.dishes_categories.forEach(category => {
                category.count = 0
            })

            let popular = state.outlet.data.dishes_categories.find(cat => {
                return cat.id === 0
            })
            state.products.forEach(element => {
                state.outlet.data.dishes_categories.forEach(category => {
                    if (element.category_id === category.id) {
                        category.count++
                    }
                })
                if (popular != null && element.is_top === 1) {
                    popular.count++
                }
            })

        } else {
            state.outlet.data.resources_categories.forEach(category => {
                category.count = 0
            })

            let popular = state.outlet.data.resources_categories.find(cat => {
                return cat.id === 0
            })
            state.products.forEach(element => {
                state.outlet.data.resources_categories.forEach(category => {
                    if (element.category_id === category.id) {
                        category.count++
                    }
                })
                if (popular != null && element.is_top === 1) {
                    popular.count++
                }
            })
        }
    },

    [SET_BOT_LINK](state, data) {
        state.outlet.data.settings.bot_link = data
    },

    [SET_LINKS](state, data) {
        if (data.data.dishes) {
            state.outlet.links = data.data.dishes.links
        }
        if (data.data.resources) {
            state.outlet.links = data.data.resources.links
        }
    },

    [SET_OUTLET](state, data) {
        state.outlet = data
        document.title = data.data.company
    },

    [SET_TIMES](state, data) {
        state.outlet.data.settings.delivery_time = data
    },

    [ADD_TO_PRODUCTS](state, data) {
        for (let i in data) {
            const product = data[i]
            let add = true
            for (let j = 0; j < state.products.length; j++) {
                const addedProduct = state.products[j]

                if (product.id === addedProduct.id) {
                    add = false
                }
            }

            if (add) {
                state.products.push(product)
            }
        }
    },

    [ADD_CATEGORIES](state, data) {
        for (let key in data) {
            // if (!state.selectedCategory.hasOwnProperty(data[key].level)) {
            //   Vue.set(state.selectedCategory, data[key].level, {
            //     current: {
            //       id: null,
            //     },
            //     previous: {
            //       id: null,
            //     },
            //   })
            // }
            state.categories[key] = data[key]
        }
    },

    [SET_FILTER](state, { filter, data }) {
        state.filter[filter] = data
    },

    [SET_NEXT_PAGE](state, data) {
        state.outlet.links.next = data
    },
}

export default {
    state,
    actions,
    mutations,
    getters
}